import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBriefcase = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3 22.5h18a3 3 0 0 0 3 -3v-11a3 3 0 0 0 -3 -3h-3.9a0.24 0.24 0 0 1 -0.24 -0.22l-0.15 -1.15a3 3 0 0 0 -3 -2.63h-3.44a3 3 0 0 0 -3 2.63l-0.13 1.15a0.24 0.24 0 0 1 -0.24 0.22H3a3 3 0 0 0 -3 3v11a3 3 0 0 0 3 3ZM9.27 4.38a1 1 0 0 1 1 -0.88h3.46a1 1 0 0 1 1 0.88l0.1 0.84a0.25 0.25 0 0 1 -0.06 0.2 0.26 0.26 0 0 1 -0.19 0.08H9.42a0.26 0.26 0 0 1 -0.19 -0.08 0.25 0.25 0 0 1 -0.06 -0.2ZM5.25 11a0.76 0.76 0 0 1 0.75 -0.75h12a0.76 0.76 0 0 1 0.75 0.75v0.5a0.76 0.76 0 0 1 -0.75 0.75H6a0.76 0.76 0 0 1 -0.75 -0.75Zm0 5.5a0.76 0.76 0 0 1 0.75 -0.75h12a0.76 0.76 0 0 1 0.75 0.75v0.5a0.76 0.76 0 0 1 -0.75 0.75H6a0.76 0.76 0 0 1 -0.75 -0.75Z",
		fill: "currentColor",
		strokeWidth: 1
	})
});
export { SvgBriefcase as ReactComponent };
